import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MerchantService } from 'app/services';

@Component({
    selector: 'suspend-partner',
    templateUrl: './suspend-partner.component.html',
    styleUrls: ['./suspend-partner.component.scss'],
    providers: [MessageService]
})
export class SuspendPartnerComponent implements OnInit {
    @Input() public merchant: any;

    public displayModalSuspend: boolean = false;
    @Input()
    set _displayModalSuspend(value: boolean) {
        this.displayModalSuspend = value;
    }

    @Output() changedDisplayModalSuspendEmit = new EventEmitter<boolean>();
    changeDisplayModalSuspend(increased: any) {
        this.changedDisplayModalSuspendEmit.emit(increased);
    }

    public activeResumeButton: boolean = false;

    public loading: boolean = false;

    constructor(
        private messageService: MessageService,
        private merchantService: MerchantService
    ) { }

    ngOnInit(): void {
        this.activeResumeButton = this.merchant.SuspendUntilDays === 0 ? false : true;
    }

    public saveSuspend(checkDate: boolean = true) {
        console.log(this.merchant);
        const dto = {
            MerchantId: this.merchant.Id,
            AmountDays: this.merchant.SuspendUntilDays
        };
        if (!checkDate) {
            dto.AmountDays = 0;
        }

        if (dto.AmountDays !== null &&
            dto.MerchantId !== 0 && dto.MerchantId !== null && (checkDate && dto.AmountDays !== 0 || !checkDate)) {
            this.loading = true;

            this.merchantService.suspendMerchant(dto, this.messageService)
                .then(data => {
                    if (!data.Success) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                        this.loading = false;
                        return;
                    }

                    this.displayModalSuspend = !this.displayModalSuspend;
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data saved successfully' });
                    this.loading = false;
                    if (!checkDate) {
                        this.merchant.SuspendUntilDays = 0;
                    }
                })
                .catch(err => {
                    this.loading = false;
                    throw err;
                });
        }
        else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Enter the correct day. 1 to 36500' });
        }
    }

    cancel() {
        this.changeDisplayModalSuspend(this.displayModalSuspend);
    }
}
